import { createSlice } from "@reduxjs/toolkit";

const initialPoState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  poForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const poSlice = createSlice({
  name: "po",
  initialState: initialPoState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		poFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    poCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.po.push(action.payload.po);
    },
    poDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.po.filter(el => el.po_id !== action.payload.id);
    },
    getPo: (state, action) => {
      state.actionsLoading = false;
      state.poForEdit = action.payload.poForEdit;
      state.error = null;
    },
    // updateProduct
    poUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.po = state.entities.po.map(entity => {
        if (entity.po_id === action.payload.po.po_id) {
          return action.payload.po;
        }
        return entity;
      });
    },
  },
});
